export function isValid(val){
    return val === 0 || (val && val!=='*')
}


// WEBPACK FOOTER //
// ./src/utilities/isValid.js